module.exports = __webpack_public_path__ + "static/wallpaper2.50ab8e7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallpaper2.jpg
// module id = 442
// module chunks = 35783957827783